import { StorageService } from 'src/app/shared/service/storage/storage.service';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { UserControlService } from 'src/app/shared/service/userControl/user-control.service';
import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { forkJoin, tap } from 'rxjs';

@Component({
    selector: 'app-maintenance',
    templateUrl: './app.maintenance.html',
    standalone :false
})

export class AppMaintenanceComponent {
    constructor(private userControlService: UserControlService, private authService: AuthService, private router: Router, private storageService: StorageService) {
        forkJoin([
            this.userControlService.getCompanyDetails()
          ])
          .pipe(
            tap(([companies]) => {
              if (companies) {
                this.authService.logout();
              }
            })
          )
          .subscribe({
            next: () => {},
            error: err => console.error(err)
          });
          
        }
}
